export const isAuthenticated = () =>
  localStorage.getItem('user_token') !== null;
